import authService from '../../../services/auth'
import BillingView from '../../share/billing-view'
export default {
    components: {
        BillingView
    },
    data() {
        return {
            orgId: '',
            orgName: '',
            billingFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            billingToDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
            billing_filter_val: 'current_month',
        }
    },
    created() {
        this.orgId = this.$store.state.organization.id
        this.orgName = this.$store.state.organization.name
    },
}